<template>
    <div class="establishModalWrap">
        <div class="mask" @click="closeModal"></div>
        <div class="establishBox">
           <div class="title">账户审核</div>
           <div class="oneArea">
               <div class="oneline"><span class="mylabel">用户名</span><span class="text">{{infoObj.user_organization_name||infoObj.user_individual_name}}</span></div>
               <div class="oneline"><span class="mylabel">注册手机</span><span class="text">{{infoObj.user_cellphone}}</span></div>
              <div class="oneline"><span class="mylabel">用户Id</span><span class="text">{{infoObj.user_id}}</span></div>
           </div>
           <div class="oneArea">
               <div class="oneline">
                   <span class="mylabel"><i class="redStar">*</i> 审核结果：</span>
                   <el-radio v-model="result" label="y">通过</el-radio>
                   <el-radio v-model="result" label="n">拒绝</el-radio>
                   <!-- <el-radio v-model="result" label="p">待审核</el-radio> -->
               </div>
               <div class="oneline">
                 <el-input
                   type="textarea"
                   :rows="3"
                   placeholder="请输入通过或拒绝的理由(非必填)"
                   v-model="memo">
                 </el-input>
               </div>

           </div>
           <div class="footer">
               <button class="closeBtn btn" @click="closeModal">取消</button>
               <button class="submitBtn btn" @click="submitClick">确定</button>
           </div>
       </div>

    </div>
</template>

<script>
    import { ajaxPost, api } from "@/common/request.js";
    import { json, wordData, utils } from "@/common/common.js";

    export default {
      name: 'hexiao',
      props: ["info"],
      computed: {
        infoObj(){
          console.log(this.info)
            return this.info
        },
        adminId() {
          return utils.getAdminId()
        },
      },
      data () {
        return {
            result:"",
            memo:'',
        }
      },
      watch: {
      },
      methods: {
          closeModal(){
              this.$emit("close")
              this.memo=''
              this.result=''
          },
          closeModalAndSuccess(){
              this.$emit("success")
              this.memo=''
              this.result=''
          },
          submitClick(){
              let _this=this
              let arg={
                userState:_this.result,
                userId:_this.infoObj.user_id,
                userReviewMemo:_this.memo,
              }
              console.log(arg)
              if(!this.result){
                  this.$message.error('您还未选择审核结果')
              }else{

                  ajaxPost("/admin/updateDwUserInfoStatus",arg).then(res => {
                      if (res.errorCode == 200) {
                          this.$message.success(res.errorMsg || '操作成功')
                          this.closeModalAndSuccess()
                      } else {
                          this.$message.error(res.errorMsg || '操作失败')
                      }
                  }).catch(err => {
                      console.log(err)
                  })
              }
          }
      },
      mounted() {

      }
    }
</script>

<style scoped lang="scss">
.establishModalWrap{
    position: fixed;
    top:0;left:0;right:0;bottom:0;
    z-index:100;
    .mask{
        background:rgba(0,0,0,0.5);
        position: fixed;
        top:0;left:0;right:0;bottom:0;
    }
    .establishBox{
        position: fixed;z-index:1000;
        left:33%;top:20%;
        width: 30%;min-width: 300px; border:1px solid #eee;border-radius: 4px;
        background: #fff;border-radius: 2px;
        input{border:1px solid #ddd;border-radius: 4px;padding:8px;}
        .title{
            font-size: 18px;
            padding:19px 25px;
            border-bottom: 1px solid #eee;
        }
        .oneArea{margin:20px 0;}
        .oneline{margin:10px 0;padding:0 25px;
        }
        .mylabel{position: relative; display: inline-block;min-width: 60px;text-align-last: justify;margin-right: 20px;font-weight: bold;
          .redStar{position: absolute;left:-10px;top:0;}
        }
        .text{}

        .footer{
            text-align: right;
            border-top: 1px solid #eee;
            padding:14px 25px;
            .btn{padding:5px 16px;background: #fff;font-size: 12px;border-radius: 4px;}
            .closeBtn{margin-right: 10px;border:1px solid #D9D9D9;}
            .submitBtn{background: #F81D22;color:#fff;border:0;}
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/userauth.vue